import styled from 'styled-components';

export const Container = styled.div`
  .desktop-warning {
    text-align: center;

    a {
      color: inherit;
      text-decoration: underline;
    }
  }

  .rules-table {
    border: 1px solid ${(props) => props.theme.$gray300};
    margin-bottom: 16px;

    th {
      background: ${(props) => props.theme.$gray200};
      border-top: 0;
      border-bottom: 0;
      font-weight: 700;
      white-space: nowrap;
    }

    td {
      vertical-align: middle;
    }

    .rule-label {
      word-break: break-word;
    }

    .rule-channel {
      margin: 2px 20px 2px 0;
      white-space: nowrap;
    }

    .rule-channel-email {
      min-width: 96px;
    }

    .control-checkbox input + .control_indicator::before,
    .control-checkbox input:checked + .control_indicator::before {
      display: none;
      animation: none;
    }

    .rule-remove {
      width: 40px;
      text-align: center;

      .material-icons {
        font-size: 20px;
      }
    }
  }

  .monitoring-help-mark {
    font-size: 9px;
    height: 16px;
    width: 16px;
    font-weight: bold;
    text-align: center;
    margin-top: 1px;
    padding-top: 1px;
  }
`;
